<template>
    <v-tooltip bottom v-if="visible">
        <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" class="px-3" min-width="0" role="status" aria-live="polite" :aria-label="label" e2e-live-updates-indicator>
                <v-icon small :color="chipColor" :class="{ pulse: pulsing }">mdi-circle</v-icon>
            </v-btn>
        </template>
        <span>{{ label }}</span>
    </v-tooltip>
</template>

<script>
import { getStatus, onStatus, isPushUiEnabled, onPushUiEnabled } from '@/push'

export default {
    name: 'LiveUpdatesIndicator',
    data() {
        return {
            status: getStatus(),
            pushUiEnabled: isPushUiEnabled(),
            unsub: null,
            unsubUi: null
        }
    },
    computed: {
        visible() {
            // Only after a real push connect this session — never "Connecting…" forever on old BE.
            return this.$auth?.isAuthenticated && this.pushUiEnabled
        },
        label() {
            if (this.status === 'connected') return 'Live updates on'
            if (this.status === 'reconnecting') return 'Reconnecting…'
            return 'Connecting…'
        },
        chipColor() {
            return this.status === 'connected' ? 'success' : 'amber darken-2'
        },
        pulsing() {
            return this.status === 'connecting' || this.status === 'reconnecting'
        }
    },
    created() {
        this.unsub = onStatus(payload => {
            this.status = payload.status
        })
        this.unsubUi = onPushUiEnabled(enabled => {
            this.pushUiEnabled = enabled
        })
    },
    beforeDestroy() {
        if (this.unsub) {
            this.unsub()
            this.unsub = null
        }
        if (this.unsubUi) {
            this.unsubUi()
            this.unsubUi = null
        }
    }
}
</script>

<style scoped>
.pulse {
    animation: liveUpdatesPulse 1.2s ease-in-out infinite;
}
@keyframes liveUpdatesPulse {
    0%,
    100% {
        opacity: 0.35;
        transform: scale(0.85);
    }
    50% {
        opacity: 1;
        transform: scale(1.15);
    }
}
@media (prefers-reduced-motion: reduce) {
    .pulse {
        animation: none;
    }
}
</style>
